<template>
  <div class="summary-card is-courses">
    <div>
      <span>دوره‌های من</span>
      <strong>{{ totalCount }}</strong>
      <small>دوره فعال</small>
    </div>
    <img src="../../../../../public/course.webp" alt="">
  </div>
</template>
<script>
export default {
  name: "MyCourse",
  data() {
    return {
      paginationMeta: {},
    }
  },
  computed: {
    totalCount() {
      const meta = this.paginationMeta || {}
      return meta.total == null ? 0 : meta.total
    },
  },
  methods: {
    async setUserCourse(form) {
      const res = await this.$store.dispatch("Course/getUserCourses", form)
      const data = res.data.data
      this.paginationMeta = data.meta || {}
    },
  },
  async mounted() {
    await this.setUserCourse({
      page: 1,
      user_id: this.$store.getters['User/getUserId'],
    })
  },
}
</script>
<style scoped>
.summary-card {
  position: relative;
  overflow: hidden;
  min-height: 148px;
  border-radius: 20px;
  padding: 20px 18px;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  box-shadow: 0 12px 28px rgba(30, 30, 30, 0.16);
}

.summary-card::before {
  content: "";
  position: absolute;
  inset: 0;
  background-image:
    radial-gradient(rgba(255, 255, 255, 0.08) 1px, transparent 1px),
    linear-gradient(225deg, rgba(235, 61, 96, 0.22), transparent 58%);
  background-size: 12px 12px, auto;
  pointer-events: none;
}

.summary-card > * {
  position: relative;
  z-index: 1;
}

.summary-card span,
.summary-card small {
  display: block;
  opacity: 0.78;
  font-size: 13px;
}

.summary-card strong {
  display: block;
  font-size: 36px;
  line-height: 1.2;
  font-weight: 800;
}

.summary-card img {
  height: 72px;
  width: auto;
  max-width: 38%;
  object-fit: contain;
}

.is-courses {
  background: linear-gradient(145deg, #1e1e1e 0%, #252525 100%);
}
</style>
